import type { P6uBand, P6uPublisherBook, P6uSubject } from "p6m-p6u";
import { useState } from "react";
import { useBookContext } from "../../../context/BookContext";
import { isBlockedByFilters } from "../../../helpers/BookAvailability";
import { getRequest } from "../../../helpers/networkHelper";

/** The old dropdowns' options, loaded from p6u one step at a time as the teacher picks. */
const useBookDropdownOptions = () => {
    const { bookFilters } = useBookContext();

    const [availableSubjects, setAvailableSubjects] = useState<Array<P6uSubject>>([]);
    const [availablePublishersAndBooks, setAvailablePublishersAndBooks] = useState<Array<P6uPublisherBook>>([]);
    const [availableBands, setAvailableBands] = useState<Array<P6uBand>>([]);

    function loadAvailableSubjects() {
        getRequest("p6u/get-subjects/").then((response) => {
            if (response.data) {
                const subjects: Array<P6uSubject> = response.data;
                setAvailableSubjects(
                    subjects.filter((subject) => !isBlockedByFilters({ subjectId: subject.ID }, bookFilters))
                );
            }
        });
    }

    function loadPublisherBooksForSubject(subject: string) {
        getRequest("p6u/get-subject-publishers-and-books/", { subject }).then((response) => {
            if (response.data) {
                const publishersBooks: Array<P6uPublisherBook> = response.data;
                setAvailablePublishersAndBooks(
                    publishersBooks.filter(
                        (publisherBook) =>
                            !isBlockedByFilters(
                                { publisherId: publisherBook.PublisherID, bookId: publisherBook.BookID },
                                bookFilters
                            )
                    )
                );
            }
        });
    }

    function loadBandsForBook(subject: string, publisherAndBookId: string) {
        const [publisher, book] = publisherAndBookId.split("*");

        if (!publisher || !book) {
            return;
        }

        getRequest("p6u/get-bands-for-book/", { subject, publisher, book }).then((response) => {
            if (response.data) {
                setAvailableBands(response.data);
            }
        });
    }

    return {
        availableSubjects,
        loadAvailableSubjects,
        availablePublishersAndBooks,
        setAvailablePublishersAndBooks,
        loadPublisherBooksForSubject,
        availableBands,
        setAvailableBands,
        loadBandsForBook,
    };
};

export default useBookDropdownOptions;
